import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { sendPerkProviderForm } from '../services/api';
import './Perks.css';

function Perks() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    website: '',
    offerDetails: '',
    companyDescription: '',
    perkType: 'Redemption URL (Users can click on a link to redeem the perk)',
    redemptionInstructions: ''
  });
  
  const [formStatus, setFormStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showProviderForm, setShowProviderForm] = useState(false);
  const formRef = useRef(null);
  
  // Scroll to top of form when opened
  useEffect(() => {
    if (showProviderForm && formRef.current) {
      formRef.current.scrollTop = 0;
    }
  }, [showProviderForm]);
  
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const messageData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone || '',
        message: `
Perk Provider Submission:
------------------------
Company Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone || 'Not provided'}
Website URL: ${formData.website}

Offer Details:
${formData.offerDetails}

Company Description:
${formData.companyDescription}

Perk Type:
${formData.perkType}

Redemption Instructions:
${formData.redemptionInstructions}
        `
      };
      
      await sendPerkProviderForm(messageData);
      setFormStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        website: '',
        offerDetails: '',
        companyDescription: '',
        perkType: 'Redemption URL (Users can click on a link to redeem the perk)',
        redemptionInstructions: ''
      });
    } catch (error) {
      console.error('Error submitting perk provider form:', error);
      setFormStatus('error');
    } finally {
      setLoading(false);
      
      // Reset status after 5 seconds
      setTimeout(() => {
        setFormStatus(null);
      }, 5000);
    }
  };
  
  return (
    <div className="perks-page">
      <div className="perks-hero">
        <div className="container">
          <h1 className="perks-title">rkube Perks</h1>
          <p className="perks-subtitle">Curate a startup stack that optimizes for growth</p>
          
          <div className="perks-actions">
            {/* <button 
              className="perks-btn primary-btn"
              onClick={() => setShowProviderForm(true)}
            >List a Perk</button> */}
            {/* <button className="perks-btn secondary-btn">Login to Redeem</button> */}
          </div>
        </div>
      </div>

      <div className="perks-content container">
        <div className="our-perks">
          <div className="perk-card">
            <Link to="/books" className="perk-card-inner">
              <div className="perk-logo">
                <svg width="120" height="44" viewBox="0 0 282 104" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="paint0_linear_241_27" x1="0" y1="0" x2="282.286" y2="104" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#8F05FC"></stop>
                      <stop offset="1" stopColor="#5024FF"></stop>
                    </linearGradient>
                  </defs>
                  <text x="10" y="70" fontSize="90" fontWeight="bold" fill="url(#paint0_linear_241_27)" fontFamily="Arial, sans-serif">rkube</text>
                </svg>
              </div>
              <h3 className="perk-name">rkube Books</h3>
              <p className="perk-description">Free trial access to our financial bookkeeping services</p>
            </Link>
          </div>
        </div>

        <h2 className="explore-title">Explore our perks</h2>
        <p className="coming-soon">More perks coming soon</p>
        <div className="perks-actions">
            <button 
              className="perks-btn primary-btn"
              onClick={() => setShowProviderForm(true)}
            >List a Perk with rkube</button>
            {/* <button className="perks-btn secondary-btn">Login to Redeem</button> */}
        </div>
        
        {/* Perk Provider Form */}
        {showProviderForm && (
          <div className="perk-provider-form-container">
            <div className="perk-provider-form" ref={formRef}>
              <div className="perk-provider-form-header">
                <h2>Become a perk provider</h2>
                <p>List your offering on rkube's perk ecosystem</p>
                <button 
                  className="close-form-btn"
                  onClick={() => setShowProviderForm(false)}
                >×</button>
              </div>
              
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Company name<span className="required">*</span></label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">Email<span className="required">*</span></label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="website">Website URL<span className="required">*</span></label>
                    <input
                      type="url"
                      id="website"
                      name="website"
                      value={formData.website}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="offerDetails">Offer details<span className="required">*</span></label>
                  <textarea
                    id="offerDetails"
                    name="offerDetails"
                    value={formData.offerDetails}
                    onChange={handleChange}
                    required
                    rows="4"
                  ></textarea>
                </div>
                
                <div className="form-group">
                  <label htmlFor="companyDescription">Company description<span className="required">*</span></label>
                  <textarea
                    id="companyDescription"
                    name="companyDescription"
                    value={formData.companyDescription}
                    onChange={handleChange}
                    required
                    rows="4"
                  ></textarea>
                </div>
                
                <div className="form-group">
                  <label htmlFor="perkType">Perk type<span className="required">*</span></label>
                  <select
                    id="perkType"
                    name="perkType"
                    value={formData.perkType}
                    onChange={handleChange}
                    required
                  >
                    <option value="Redemption URL (Users can click on a link to redeem the perk)">Redemption URL (Users can click on a link to redeem the perk)</option>
                    <option value="Promo code (Users can use a specific code on checkout on your platform)">Promo code (Users can use a specific code on checkout on your platform)</option>
                    <option value="Perk redemption email (Users can redeem the perk by emailing this address)">Perk redemption email (Users can redeem the perk by emailing this address)</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="redemptionInstructions">Perk redemption instructions<span className="required">*</span></label>
                  <textarea
                    id="redemptionInstructions"
                    name="redemptionInstructions"
                    value={formData.redemptionInstructions}
                    onChange={handleChange}
                    required
                    rows="4"
                  ></textarea>
                </div>
                
                <div className="activation-help">
                  Want to learn how to improve perk activation? Click <a href="#" className="help-link">here</a>
                </div>
                
                <button 
                  type="submit" 
                  className="submit-perk-btn" 
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit Perk'}
                </button>
                
                {formStatus === 'success' && (
                  <div className="form-success-message">
                    Thank you! Your perk provider submission has been received.
                  </div>
                )}
                
                {formStatus === 'error' && (
                  <div className="form-error-message">
                    An error occurred. Please try again later.
                  </div>
                )}
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Perks; 